/**
 * General Styles For The Layout
 * @type {function(*): {}}
 */
//@ts-nocheck

import { EnglishFont } from "../../utils/Fonts";
import { alpha } from "@material-ui/core";

export const useStyles = (theme: any) => ({
  "@global": {
    html: { minHeight: "100%" },
    body: {
      height: "100%",
      backgroundColor: theme.palette.colors.body,
    },
    "#root": {
      height: "100%",
      whiteSpace: "pre-line",
    },
    a: {
      transition: "all 0.3s ease-in-out",
      color: theme.palette.primary.main,
      "&:hover, &:focus": {
        color: theme.palette.secondary.main,
      },
    },
    button: {
      fontFamily: theme.direction === "ltr" ? EnglishFont : English,
      cursor: "pointer",
      transition: "all 0.3s ease-in-out",
      outline: "none !important",
    },
    img: {
      maxWidth: "100%",
      height: "auto",
      display: "inline-block",
    },
    ".require": {
      color: theme.palette.error.main,
    },
    h1: {
      fontFamily: theme.direction === "ltr" ? EnglishFont : EnglishFont,
      fontWeight: 800,
      color: theme.palette.text.primary,
      fontSize: "32px",
      margin: "0 0 24px 0",
      textAlign: "start",
    },
    h2: {
      fontFamily: theme.direction === "ltr" ? EnglishFont : EnglishFont,
      fontWeight: 700,
      fontSize: "24px",
      color: theme.palette.text.secondary,
      margin: "0 0 0px 0",
      textAlign: "start",
    },
    h3: {
      fontFamily: theme.direction === "ltr" ? EnglishFont : EnglishFont,
      fontWeight: 600,
      fontSize: "20px",
      color: theme.palette.text.secondary,
      margin: "0 0 0px 0",
      textAlign: "start",
    },
    h4: {
      fontFamily: theme.direction === "ltr" ? EnglishFont : EnglishFont,
      fontWeight: 600,
      fontSize: "18px",
      color: theme.palette.text.secondary,
      margin: "0 0 0px 0",
    },
    h5: {
      fontFamily: theme.direction === "ltr" ? EnglishFont : EnglishFont,
      fontWeight: 600,
      fontSize: "16px",
      color: theme.palette.text.primary,
      margin: "0 0 0px 0",
      textAlign: "start",
    },

    h6: {
      fontFamily: theme.direction === "ltr" ? EnglishFont : EnglishFont,
      fontWeight: 600,
      fontSize: "14px",
      color: theme.palette.text.primary,
      margin: "0 0 0px 0",
      textAlign: "start",
    },

    // span: {
    //   fontFamily: theme.direction === "ltr" ? EnglishFont : EnglishFont,
    //   fontWeight: 400,
    //   color: theme.palette.colors.body,
    // },

    ".grecaptcha-badge": {
      visibility: "hidden",
    },
    ".css-1u4zpwo-MuiSvgIcon-root-MuiStepIcon-root.Mui-completed": {
      color: "#07A26A !important",
    },
    ".css-1u4zpwo-MuiSvgIcon-root-MuiStepIcon-root.Mui-active": {
      color: "#1E70FC",
    },
    ".MuiOutlinedInput-root": {
      borderRadius: "10px !important",
      color: theme.palette.primary.main,
      // height: "48px",
      justifyContent: "center",
      "&:hover, &:focus": {
        borderColor: "#fff !important",
        borderWidth: "5px",
        cursor: "pointer",
        borderRadius: "10px",
      },
    },
    ".MuiInputBase-root": {
      color: theme.palette.primary.main,

      "&:hover, &:focus": {
        borderColor: "#fff",
        borderWidth: "5px",
        cursor: "pointer",
        borderRadius: "10px",
      },
    },
    ".MuiStepper-root ": {
      width: "100%",
    },
    ".MuiStepLabel-label": {
      fontFamily: theme.direction === "ltr" ? EnglishFont : EnglishFont,
      fontWeight: 700,
      fontSize: "16px",
      color: theme.palette.text.primary,
      margin: "0 0 0px 0",
      textAlign: "end",
    },
    ".MuiDrawer-paper": {
      backgroundColor: theme.palette.common.black,
    },
    ".MuiBackdrop-root": {
      backgroundColor: alpha(theme.palette.common.black, 0.75),
    },
    ".MuiAutocomplete-listbox": {
      direction:
        theme.direction === "ltr" ? "rtl !important" : "ltr !important",
    },
    "::selection": {
      color: theme.palette.common.white,
      background: theme.palette.primary.main,
    },
    ".MuiButtonBase-root-MuiTab-root.Mui-selected": {
      color: "#1E70FC",
    },
    ".MuiTab-textColorPrimary": {
      color: "#1E70FC",
    },
    ".Mui-selected": {
      color: "#1E70FC",
    },
    ".css-1h9z7r5-MuiButtonBase-root-MuiTab-root.Mui-selected": {
      color: "#1E70FC !important",
    },
    ".MuiButton-contained": {
      color: "#ffffff",
      boxShadow: "none",
      backgroundColor: theme.palette.primary.main,
      fontWeight: 600,
      fontFamily: theme.direction === "ltr" ? EnglishFont : EnglishFont,
      fontSize: "14px",
      maxHeight: "48px",
      minHeight: "48px",
      height: "48px !important",
      textTransform: "none",
      padding: theme.spacing(1, 6, 1, 6),
      borderRadius: "8px",
      margin: 0,
    },
    ".MuiButton-outlined": {
      color: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      backgroundColor: "#fff",
      fontWeight: 600,
      fontFamily: theme.direction === "ltr" ? EnglishFont : EnglishFont,
      fontSize: "14px",
      height: "48px !important",
      textTransform: "none",
      padding: theme.spacing(1, 6, 1, 6),
      borderRadius: "8px",

      "&:hover, &:focus": {
        color: "#fff",
        backgroundColor: theme.palette.primary.main,
        boxShadow: "none",
      },
    },
    ".MuiMenu-paper": {
      top: " 75px",
      width: "220px !important",
      backgroundColor: theme.palette.text.third,
    },
    ".MuiButton-contained:hover": {
      backgroundColor: theme.palette.primary.main,
      opacity: 0.8,
      boxShadow: "none",
    },
    ".MuiTooltip-tooltip": {
      fontSize: "12px",
    },
    ".MuiRadio-colorSecondary.Mui-checked": {
      color: `${theme.palette.primary.main} !important `,
    },
    ".page-content-wrapper": {
      width: "100%",
      whiteSpace: "normal",
      "& a": {
        wordBreak: "break-word",
      },
      "& pre": {
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
      },
    },
    ".mar-bottom-3": {
      marginBottom: theme.spacing(3),
    },
    ".scrollbar": {
      width: "1em",
      height: "1em",
    },

    "::-webkit-scrollbar": {
      width: "5px",
      height: "5px",
    },
    "::-webkit-scrollbar-track": {
      backgroundColor: "white !important",
      width: "5px",
      height: "5px",
    },
    "::-webkit-scrollbar-thumb": {
      backgroundColor: `${theme.palette.secondary.light} !important`,
      borderRadius: "10px",
      width: "5px",
      height: "5px",
    },
    ':root': {
      '--spacing-xs': '8px',
      '--spacing-sm': '16px',
      '--spacing-md': '32px',
      '--spacing-lg': '48px',
      '--spacing-xl': '64px',
    },
  },
  pageWrapper: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    minHeight: "100vh",
    maxWidth: "100%",
    overflowX: "hidden",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    background: "#F2F2F2",
    minHeight: "calc(100vh - 80px)",
    paddingTop: "96px",
    paddingBottom: "82px",
    paddingLeft: "16px",
    paddingRight: "16px",
    boxSizing: "border-box",
    width: "100%",
    overflowX: "hidden",
    [theme.breakpoints.down("md")]: {
      paddingTop: "72px",
      paddingBottom: "74px",
    },
    [theme.breakpoints.down("sm")]: {
      paddingTop: "64px",
      paddingBottom: "24px",
      paddingLeft: "8px",
      paddingRight: "8px",
    },
  },

  pageCard: {
    width: '100%',
    maxWidth: '1280px',
    background: '#fff',
    borderRadius: '12px',
    padding: '32px',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '32px',
    boxSizing: 'border-box',
    height: 'auto',
    overflowX: 'hidden',
    '& > *': { flex: '0 0 auto' },
    [theme.breakpoints.down('md')]: {
      padding: '24px 16px',
      borderRadius: '8px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '16px 8px',
      borderRadius: '4px',
    },
  },
  content2: {
    flex: "1 1 auto",
    background: "#fff",
    paddingTop: theme.spacing(14.5),
    paddingBottom: "82px",
    overflowY: "auto",
    overflowX: "hidden",
    boxSizing: "border-box",
    [theme.breakpoints.down("md")]: {
      paddingTop: theme.spacing(9.5),
      paddingBottom: "82px",
    },
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "24px",
    },
  },
});
